// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserDetails_pageWrap__wKy0z {
  padding: 4px 4px 32px;
}

/* =========================================================
   Hero banner
   ========================================================= */
.UserDetails_hero__zqxBV {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 20px;
  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);
  border-radius: 18px;
  padding: 28px 30px;
  margin: 16px 16px 20px;
  box-shadow: 0 16px 34px rgba(76, 47, 179, 0.24);
}

.UserDetails_hero__zqxBV::before {
  content: "";
  position: absolute;
  top: -60px;
  right: -40px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  pointer-events: none;
}

.UserDetails_hero__zqxBV::after {
  content: "";
  position: absolute;
  bottom: -70px;
  right: 110px;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  pointer-events: none;
}

.UserDetails_avatarRing__u02c1 {
  position: relative;
  z-index: 1;
  border-radius: 50%;
  padding: 4px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
  flex-shrink: 0;
}

.UserDetails_heroText__tCFnw {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.UserDetails_companyName__yyxAN {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.01em;
}

.UserDetails_heroMetaRow__yJJQK {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.UserDetails_sellerIdChip__m6v5v {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.24);
  color: #ffffff;
  font-size: 12.5px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 10px;
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
}

/* =========================================================
   Form card
   ========================================================= */
.UserDetails_formCard__e2uyo {
  margin: 0 16px 24px !important;
  border-radius: 18px !important;
  border: 1px solid #E7E9F1 !important;
  box-shadow: 0 10px 28px rgba(27, 37, 89, 0.06) !important;
}

.UserDetails_formCard__e2uyo .ant-card-body {
  padding: 28px 30px;
}

.UserDetails_sectionTitle__6GANU {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #1F2430;
  margin: 0 0 18px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EEF0F6;
}

.UserDetails_sectionTitle__6GANU:not(:first-child) {
  margin-top: 8px;
}

.UserDetails_formCard__e2uyo .ant-form-item-label > label {
  font-size: 12px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.UserDetails_formCard__e2uyo .ant-input {
  border-radius: 10px;
  border-color: #E5E7EB;
  padding: 8px 12px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.UserDetails_formCard__e2uyo .ant-input:hover {
  border-color: #a78bfa;
}

.UserDetails_formCard__e2uyo .ant-input:focus,
.UserDetails_formCard__e2uyo .ant-input-focused {
  border-color: #4c2fb3 !important;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15) !important;
}

.UserDetails_formCard__e2uyo .ant-upload .ant-btn {
  border-radius: 10px;
  border-color: #DCD3F9;
  color: #4c2fb3;
  font-weight: 600;
}

.UserDetails_formCard__e2uyo .ant-upload .ant-btn:hover {
  border-color: #7c5cfc !important;
  color: #4c2fb3 !important;
  background: #F3EFFD;
}

.UserDetails_formCard__e2uyo .ant-upload.ant-upload-select-picture-card {
  border-radius: 12px;
  border-color: #DCD3F9;
  background: #FAF8FF;
}

.UserDetails_formCard__e2uyo .ant-upload.ant-upload-select-picture-card:hover {
  border-color: #7c5cfc;
}

.UserDetails_formCard__e2uyo .ant-upload-list-picture-card .ant-upload-list-item {
  border-radius: 12px;
  border-color: #E5E7EB;
}

.UserDetails_submitBtn__Hg9Bg {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;
  border: none !important;
  height: 42px;
  padding: 0 28px !important;
  font-weight: 600 !important;
  box-shadow: 0 10px 22px rgba(76, 47, 179, 0.28);
  transition: transform 0.15s ease, box-shadow 0.15s ease !important;
}

.UserDetails_submitBtn__Hg9Bg:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(76, 47, 179, 0.34);
}
`, "",{"version":3,"sources":["webpack://./src/pages/UserDetails/UserDetails.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;;8DAE8D;AAC9D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0EAA0E;EAC1E,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;;8DAE8D;AAC9D;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;EAC3B,+CAA+C;EAC/C,kEAAkE;AACpE;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n/* =========================================================\n   Hero banner\n   ========================================================= */\n.hero {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);\n  border-radius: 18px;\n  padding: 28px 30px;\n  margin: 16px 16px 20px;\n  box-shadow: 0 16px 34px rgba(76, 47, 179, 0.24);\n}\n\n.hero::before {\n  content: \"\";\n  position: absolute;\n  top: -60px;\n  right: -40px;\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.08);\n  pointer-events: none;\n}\n\n.hero::after {\n  content: \"\";\n  position: absolute;\n  bottom: -70px;\n  right: 110px;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.06);\n  pointer-events: none;\n}\n\n.avatarRing {\n  position: relative;\n  z-index: 1;\n  border-radius: 50%;\n  padding: 4px;\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);\n  flex-shrink: 0;\n}\n\n.heroText {\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n}\n\n.companyName {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: -0.01em;\n}\n\n.heroMetaRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.sellerIdChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(255, 255, 255, 0.16);\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  color: #ffffff;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 6px 12px;\n  border-radius: 10px;\n  backdrop-filter: blur(6px);\n}\n\n/* =========================================================\n   Form card\n   ========================================================= */\n.formCard {\n  margin: 0 16px 24px !important;\n  border-radius: 18px !important;\n  border: 1px solid #E7E9F1 !important;\n  box-shadow: 0 10px 28px rgba(27, 37, 89, 0.06) !important;\n}\n\n.formCard :global(.ant-card-body) {\n  padding: 28px 30px;\n}\n\n.sectionTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: #1F2430;\n  margin: 0 0 18px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.sectionTitle:not(:first-child) {\n  margin-top: 8px;\n}\n\n.formCard :global(.ant-form-item-label) > label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #6B7280;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.formCard :global(.ant-input) {\n  border-radius: 10px;\n  border-color: #E5E7EB;\n  padding: 8px 12px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.formCard :global(.ant-input:hover) {\n  border-color: #a78bfa;\n}\n\n.formCard :global(.ant-input:focus),\n.formCard :global(.ant-input-focused) {\n  border-color: #4c2fb3 !important;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15) !important;\n}\n\n.formCard :global(.ant-upload) :global(.ant-btn) {\n  border-radius: 10px;\n  border-color: #DCD3F9;\n  color: #4c2fb3;\n  font-weight: 600;\n}\n\n.formCard :global(.ant-upload) :global(.ant-btn:hover) {\n  border-color: #7c5cfc !important;\n  color: #4c2fb3 !important;\n  background: #F3EFFD;\n}\n\n.formCard :global(.ant-upload.ant-upload-select-picture-card) {\n  border-radius: 12px;\n  border-color: #DCD3F9;\n  background: #FAF8FF;\n}\n\n.formCard :global(.ant-upload.ant-upload-select-picture-card:hover) {\n  border-color: #7c5cfc;\n}\n\n.formCard :global(.ant-upload-list-picture-card .ant-upload-list-item) {\n  border-radius: 12px;\n  border-color: #E5E7EB;\n}\n\n.submitBtn {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;\n  border: none !important;\n  height: 42px;\n  padding: 0 28px !important;\n  font-weight: 600 !important;\n  box-shadow: 0 10px 22px rgba(76, 47, 179, 0.28);\n  transition: transform 0.15s ease, box-shadow 0.15s ease !important;\n}\n\n.submitBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 28px rgba(76, 47, 179, 0.34);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `UserDetails_pageWrap__wKy0z`,
	"hero": `UserDetails_hero__zqxBV`,
	"avatarRing": `UserDetails_avatarRing__u02c1`,
	"heroText": `UserDetails_heroText__tCFnw`,
	"companyName": `UserDetails_companyName__yyxAN`,
	"heroMetaRow": `UserDetails_heroMetaRow__yJJQK`,
	"sellerIdChip": `UserDetails_sellerIdChip__m6v5v`,
	"formCard": `UserDetails_formCard__e2uyo`,
	"sectionTitle": `UserDetails_sectionTitle__6GANU`,
	"submitBtn": `UserDetails_submitBtn__Hg9Bg`
};
export default ___CSS_LOADER_EXPORT___;
